import * as Sentry from '@sentry/minimal';
export default function captureException(exception, // naming for consistency with Raven API
errorInfo) {
  console.error(exception, errorInfo); // eslint-disable-line no-console

  if (!errorInfo) {
    Sentry.captureException(exception);
    return;
  }

  Sentry.withScope(scope => {
    scope.setExtras(errorInfo);
    Sentry.captureException(exception);
  });
}